import { Button, Col, Grid, message, Row, Space, Typography } from "antd";
import { useStore } from "../../../context/CreateStoreContext";
import accountTypes from "../../../constants/accountTypes";
import { useState } from "react";
import { postForgotPassword } from "../../../components/apiRepository/DynamodbRepository";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

export default function Account() {
  const screen = useBreakpoint();
  const { selectedStore } = useStore();
  const [loading, setLoading] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const handleChangePassword = async (values) => {
    try {
      setLoading(true);

      const res = await postForgotPassword({ email: selectedStore?.username });

      if (res?.errors?.length > 0) {
        throw new Error(res?.errors?.[0] || "Request Failed.");
      }

      const params = new URLSearchParams();
      params.set("email", selectedStore?.username);

      navigate(`/forgotpassword/requested?${params.toString()}`, {
        state: { gobackToDashboard: true },
      });
    } catch (error) {
      setLoading(false);
      console.error(error?.message);
      console.error(error?.response?.data);
      messageApi.open({
        type: "error",
        content: error.message || "Request Failed.",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Row
        style={{
          padding: "30px",
          borderRadius: "16px",
          backgroundColor: "rgb(0 122 255 / 5%)",
          border: "1px solid #E5E5EA",
        }}
        gutter={[0, 20]}
      >
        <Col span={24}>
          <Title level={3} style={{ margin: 0, fontWeight: "bolder" }}>
            Manage Account
          </Title>
        </Col>

        <Col span={24}>
          <Row>
            <Col xs={24} lg={12}>
              <Space direction="vertical" size={0}>
                <Text type="secondary">Username/Email</Text>
                <Text strong>{selectedStore?.username}</Text>
              </Space>
            </Col>

            <Col
              xs={24}
              lg={12}
              style={{
                textAlign: screen.xs || screen.lg === false ? "start" : "end",
                paddingTop: screen.xs || screen.lg === false ? "20px" : "0",
              }}
            >
              <Button
                type="primary"
                disabled={selectedStore?.accountType !== accountTypes.owner}
                onClick={handleChangePassword}
                iconPosition="end"
                loading={loading}
                style={{ display: "inline-flex" }}
              >
                Request Change Password
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
